import React, { useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';

const HoppProConceptModel = () => {
  const { slug } = useParams();
  const [selectedImage, setSelectedImage] = useState(0);

  const models = {
    venezia: {
      name: 'Venezia',
      bruttoArea: '212 m²',
      nettoArea: '176,6 m²',
      description: 'Tágas családi ház modern kialakítással',
      fullDescription: 'A Venezia típusház a legnagyobb alapterületű modellünk, amely tágas és kényelmes otthont biztosít nagyobb családok számára. Modern kialakítás, kiváló térkihasználás.',
      features: [
        'Tágas nappali-étkező',
        '4 hálószoba',
        '2 fürdőszoba',
        'Külön garázs',
        'Terasz',
        'Energiatakarékos kialakítás'
      ],
      images: [
        '/dvb-venezia-1.jpg',
        '/dvb-venezia-2.jpg',
        '/dvb-venezia-3.jpg',
        '/dvb-venezia-4.jpg',
        '/dvb-venezia-5.jpg'
      ],
      floorPlan: '/dvb-venezia-terv.png',
      price: 'Egyedi árajánlat alapján',
      buildTime: '10-12 hét'
    },
    genova: {
      name: 'Genova',
      bruttoArea: '110 m²',
      nettoArea: '91,56 m²',
      description: 'Kompakt és praktikus alaprajz',
      fullDescription: 'A Genova típusház kompakt és praktikus alaprajzával ideális választás kisebb családok vagy párok számára. Minden szükséges funkció egy helyen.',
      features: [
        'Nappali-étkező',
        '3 hálószoba',
        '1 fürdőszoba',
        'Terasz',
        'Praktikus alaprajz',
        'Kiváló ár-érték arány'
      ],
      images: [
        '/dvb-genova-1.jpg',
        '/dvb-genova-2.jpg',
        '/dvb-genova-3.jpg',
        '/dvb-genova-4.jpg'
      ],
      floorPlan: '/dvb-genova-terv.png',
      price: 'Egyedi árajánlat alapján',
      buildTime: '8-10 hét'
    },
    verona: {
      name: 'Verona',
      bruttoArea: '100 m²',
      nettoArea: '85,5 m²',
      description: 'Ideális kisebb családok számára',
      fullDescription: 'A Verona típusház ideális kisebb családok számára, akik szeretnék a modern otthon minden előnyét élvezni, de nem igényelnek túl nagy alapterületet.',
      features: [
        'Nappali-étkező',
        '2-3 hálószoba',
        '1 fürdőszoba',
        'Terasz',
        'Optimalizált térkihasználás',
        'Alacsony fenntartási költség'
      ],
      images: [
        '/dvb-verona-1.jpg',
        '/dvb-verona-2.jpg',
        '/dvb-verona-3.jpg',
        '/dvb-verona-4.jpg',
        '/dvb-verona-5.jpg'
      ],
      floorPlan: '/dvb-verona-terv.png',
      price: 'Egyedi árajánlat alapján',
      buildTime: '8-10 hét'
    },
    siena: {
      name: 'Siena',
      bruttoArea: '64 m²',
      nettoArea: '71,3 m²',
      description: 'Költséghatékony megoldás',
      fullDescription: 'A Siena típusház a legkisebb és legköltséghatékonyabb modellünk. Tökéletes választás fiatal párok, egyedülállók vagy nyaralónak.',
      features: [
        'Nappali-étkező',
        '1-2 hálószoba',
        '1 fürdőszoba',
        'Kompakt kialakítás',
        'Költséghatékony',
        'Gyors kivitelezés'
      ],
      images: [
        '/dvb-siena-1.jpg',
        '/dvb-siena-2.jpg',
        '/dvb-siena-3.jpg',
        '/dvb-siena-4.jpg',
        '/dvb-siena-5.jpg'
      ],
      floorPlan: '/dvb-siena-terv.png',
      price: 'Egyedi árajánlat alapján',
      buildTime: '6-8 hét'
    }
  };

  const model = models[slug];

  if (!model) {
    return (
      <div className="min-h-screen bg-[#1a1a1a] text-white flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-4xl font-bold mb-4">Modell nem található</h1>
          <Link to="/hopp-proconcept" className="text-secondary hover:underline">
            Vissza a Hopp ProConcept oldalra
          </Link>
        </div>
      </div>
    );
  }

  return (
    <>
      <Helmet>
        <title>{model.name} Típusház | Hopp ProConcept | HoppHomes</title>
        <meta name="description" content={`${model.name} típusház - ${model.description}`} />
      </Helmet>

      <div className="min-h-screen bg-gradient-to-b from-[#1a1a1a] to-[#0a0a0a] text-white">
        
        {/* Breadcrumb */}
        <div className="bg-[#23272f] border-b border-white/10">
          <div className="max-w-7xl mx-auto px-4 py-4">
            <div className="flex items-center gap-2 text-sm">
              <Link to="/" className="text-gray-400 hover:text-white transition-colors">Főoldal</Link>
              <span className="text-gray-600">/</span>
              <Link to="/hopp-proconcept" className="text-gray-400 hover:text-white transition-colors">Hopp ProConcept</Link>
              <span className="text-gray-600">/</span>
              <span className="text-white">{model.name}</span>
            </div>
          </div>
        </div>

        {/* Image Gallery Section */}
        <section className="py-16 px-4">
          <div className="max-w-7xl mx-auto">
            {/* Main Image */}
            <div className="mb-6">
              <div className="aspect-video bg-gradient-to-br from-secondary/20 to-transparent rounded-2xl overflow-hidden border border-white/10">
                <img 
                  src={model.images[selectedImage]}
                  alt={`${model.name} típusház - ${selectedImage + 1}. kép`}
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
            
            {/* Thumbnail Gallery */}
            <div className="flex gap-3 sm:gap-4 mb-8 sm:mb-12 overflow-x-auto pb-3 -mx-4 px-4 sm:mx-0 sm:px-0 snap-x snap-mandatory">
              {model.images.map((image, index) => (
                <button
                  key={index}
                  onClick={() => setSelectedImage(index)}
                  className={`flex-shrink-0 w-24 sm:w-32 aspect-video rounded-lg overflow-hidden border-2 transition-all duration-200 touch-manipulation snap-center ${
                    selectedImage === index 
                      ? 'border-secondary scale-105 ring-2 ring-secondary/30' 
                      : 'border-white/10 hover:border-white/30 active:border-white/50'
                  }`}
                >
                  <img 
                    src={image}
                    alt={`${model.name} - thumbnail ${index + 1}`}
                    className="w-full h-full object-cover"
                  />
                </button>
              ))}
            </div>

            <div className="grid lg:grid-cols-2 gap-8 sm:gap-12 items-start">
              
              {/* Floor Plan */}
              <div className="order-2 lg:order-1">
                <h2 className="text-xl sm:text-2xl font-bold mb-3 sm:mb-4">Alaprajz</h2>
                <div className="bg-white rounded-xl sm:rounded-2xl overflow-hidden border border-white/10 p-3 sm:p-4">
                  <img 
                    src={model.floorPlan}
                    alt={`${model.name} alaprajz`}
                    className="w-full h-auto"
                  />
                </div>
              </div>

              {/* Info */}
              <div className="order-1 lg:order-2">
                <div className="inline-block bg-secondary/20 backdrop-blur-sm border border-secondary/30 rounded-full px-3 sm:px-4 py-1.5 sm:py-2 mb-3 sm:mb-4">
                  <span className="text-secondary font-semibold text-xs sm:text-sm">Vario-Haus Technológia</span>
                </div>
                <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4 sm:mb-6">
                  {model.name} Típusház
                </h1>
                <p className="text-base sm:text-xl text-gray-300 mb-6 sm:mb-8 leading-relaxed">
                  {model.fullDescription}
                </p>

                {/* Specs */}
                <div className="grid grid-cols-2 gap-3 sm:gap-4 mb-6 sm:mb-8">
                  <div className="bg-[#23272f] border border-white/10 rounded-lg p-3 sm:p-4">
                    <div className="text-gray-400 text-xs sm:text-sm mb-1">Bruttó terület</div>
                    <div className="text-xl sm:text-2xl font-bold text-secondary">{model.bruttoArea}</div>
                  </div>
                  <div className="bg-[#23272f] border border-white/10 rounded-lg p-3 sm:p-4">
                    <div className="text-gray-400 text-xs sm:text-sm mb-1">Nettó terület</div>
                    <div className="text-xl sm:text-2xl font-bold text-secondary">{model.nettoArea}</div>
                  </div>
                  <div className="bg-[#23272f] border border-white/10 rounded-lg p-3 sm:p-4">
                    <div className="text-gray-400 text-xs sm:text-sm mb-1">Kivitelezési idő</div>
                    <div className="text-base sm:text-xl font-bold text-white">{model.buildTime}</div>
                  </div>
                  <div className="bg-[#23272f] border border-white/10 rounded-lg p-3 sm:p-4">
                    <div className="text-gray-400 text-xs sm:text-sm mb-1">Ár</div>
                    <div className="text-sm sm:text-lg font-bold text-white">{model.price}</div>
                  </div>
                </div>

                {/* CTA Buttons */}
                <div className="flex flex-col gap-3 sm:gap-4">
                  <a 
                    href="tel:+36304130001"
                    className="bg-secondary hover:bg-hover active:bg-hover text-white font-bold px-6 sm:px-8 py-4 sm:py-5 rounded-lg transition-all duration-200 text-center text-base sm:text-lg touch-manipulation"
                  >
                    📞 Ajánlatkérés
                  </a>
                  <a 
                    href="mailto:hoppxplatform@gmail.com"
                    className="bg-white/10 hover:bg-white/20 active:bg-white/30 text-white font-bold px-6 sm:px-8 py-4 sm:py-5 rounded-lg transition-all duration-200 text-center border border-white/[0.08] text-base sm:text-lg touch-manipulation"
                  >
                    ✉️ Email küldése
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Features Section */}
        <section className="py-12 sm:py-16 px-4 bg-[#18181b]">
          <div className="max-w-7xl mx-auto">
            <h2 className="text-2xl sm:text-3xl font-bold mb-6 sm:mb-8">Főbb jellemzők</h2>
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4">
              {model.features.map((feature, index) => (
                <div 
                  key={index}
                  className="bg-[#23272f] border border-white/10 rounded-lg p-3 sm:p-4 flex items-center gap-2 sm:gap-3 touch-manipulation"
                >
                  <div className="text-xl sm:text-2xl text-secondary flex-shrink-0">✓</div>
                  <span className="text-sm sm:text-base text-gray-300">{feature}</span>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Technology Highlights */}
        <section className="py-16 px-4">
          <div className="max-w-7xl mx-auto">
            <h2 className="text-3xl font-bold mb-8">Vario-Haus Technológia előnyei</h2>
            <div className="grid md:grid-cols-2 gap-6">
              <div className="bg-[#23272f] border border-white/10 rounded-xl p-6">
                <h3 className="text-xl font-bold mb-4 text-secondary">🏭 Gyári előgyártás</h3>
                <p className="text-gray-300">
                  Az elemeket gyárban ideális körülmények között készítik el, garantálva a kiváló minőséget és pontosságot.
                </p>
              </div>
              
              <div className="bg-[#23272f] border border-white/10 rounded-xl p-6">
                <h3 className="text-xl font-bold mb-4 text-secondary">⚡ Kiváló energetika</h3>
                <p className="text-gray-300">
                  41,1 cm vastag falszerkezet, 3 rétegű energiatakarékos ablakok, U érték = 0,11 W/m²K.
                </p>
              </div>
              
              <div className="bg-[#23272f] border border-white/10 rounded-xl p-6">
                <h3 className="text-xl font-bold mb-4 text-secondary">🌿 Környezetbarát</h3>
                <p className="text-gray-300">
                  Európai faüzemben szárított fenyő anyag, természetes alapanyagok, minimális hulladék.
                </p>
              </div>
              
              <div className="bg-[#23272f] border border-white/10 rounded-xl p-6">
                <h3 className="text-xl font-bold mb-4 text-secondary">⏱️ Gyors építés</h3>
                <p className="text-gray-300">
                  A pontalapra helyezett épületek kivitelezése akár 3 hónap alatt is megoldható.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Other Models */}
        <section className="py-16 px-4 bg-[#18181b]">
          <div className="max-w-7xl mx-auto">
            <h2 className="text-3xl font-bold mb-8 text-center">További típusházak</h2>
            <div className="grid md:grid-cols-3 gap-6">
              {Object.entries(models)
                .filter(([key]) => key !== slug)
                .slice(0, 3)
                .map(([key, house]) => (
                  <Link
                    key={key}
                    to={`/hopp-proconcept/${key}`}
                    className="group bg-[#23272f] border border-white/10 rounded-xl overflow-hidden hover:border-secondary/50 transition-all duration-300"
                  >
                    <div className="aspect-video bg-gradient-to-br from-secondary/20 to-transparent overflow-hidden">
                      <img 
                        src={`/dvb-${key}.jpg`}
                        alt={house.name}
                        className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                      />
                    </div>
                    <div className="p-6">
                      <h3 className="text-xl font-bold mb-2 group-hover:text-secondary transition-colors">
                        {house.name}
                      </h3>
                      <div className="text-sm text-gray-400 space-y-1">
                        <div>Bruttó: {house.bruttoArea}</div>
                        <div>Nettó: {house.nettoArea}</div>
                      </div>
                    </div>
                  </Link>
                ))}
            </div>
            <div className="text-center mt-8">
              <Link 
                to="/hopp-proconcept"
                className="inline-block bg-secondary hover:bg-hover text-white font-bold px-8 py-3 rounded-lg transition-all duration-200"
              >
                Összes modell megtekintése
              </Link>
            </div>
          </div>
        </section>

        {/* Contact CTA */}
        <section className="py-16 px-4">
          <div className="max-w-4xl mx-auto bg-gradient-to-r from-secondary/20 to-transparent border border-secondary/30 rounded-2xl p-8 text-center">
            <div className="mb-6">
              <div className="inline-block bg-[#161616] backdrop-blur-sm border border-white/[0.08] rounded-full px-4 py-2 mb-4">
                <span className="text-sm font-semibold">🏗️ HoppHomes Saját Termék</span>
              </div>
            </div>
            <h2 className="text-3xl font-bold mb-4">
              Kérdése van a {model.name} típusházról?
            </h2>
            <p className="text-xl text-gray-300 mb-6">
              Szakértő csapatunk segít minden részletben! Hopp ProConcept termékek teljes körű tanácsadással.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a 
                href="tel:+36304130001"
                className="bg-secondary hover:bg-hover text-white font-bold px-8 py-4 rounded-lg transition-all duration-200"
              >
                📞 +36 30 413 0001
              </a>
              <a 
                href="mailto:hoppxplatform@gmail.com"
                className="bg-white/10 hover:bg-white/20 text-white font-bold px-8 py-4 rounded-lg transition-all duration-200 border border-white/[0.08]"
              >
                ✉️ hoppxplatform@gmail.com
              </a>
            </div>
          </div>
        </section>

      </div>
    </>
  );
};

export default HoppProConceptModel;
